import type { ScheduleVoyage, Voyage } from "../../shared/api/types";

// Distinguish the two voyage shapes the popup can carry: ScheduleVoyage
// (calendar selection, comes from /api/ports/schedule, has a portName)
// vs Voyage (vessels-tab selection, comes from /api/voyages, no
// portName). Several render paths need to branch on this — keep the
// discriminator logic here so it can't drift between callsites.
export function isScheduleVoyage(v: ScheduleVoyage | Voyage): v is ScheduleVoyage {
  return typeof (v as ScheduleVoyage).portName === "string";
}

export type DetailsView = "calendar" | "vessels" | null;

export interface PopupVoyageRef {
  vesselCode: string;
  voyageNo: string;
  placeholder: Voyage;
}

export interface TabSelections {
  calendar: ScheduleVoyage | null;
  vessels: Voyage | null;
}

// Resolves which voyage the details popup should display.
//
// The Prev/Next override (popupVoyageRef) always wins so popup-internal
// navigation doesn't perturb the underlying tab selection. Otherwise the
// active tab's selection drives the popup — switching tabs swaps the
// displayed voyage to that tab's last selection, matching the user's
// mental model of one selection per tab.
//
// On non-tab views (e.g. Settings) there's no selection to show, so we
// return null and the modal's <Show> gate hides itself.
export function pickModalVoyage(
  popupVoyageRef: PopupVoyageRef | null,
  tabSelections: TabSelections,
  activeView: DetailsView,
): ScheduleVoyage | Voyage | null {
  if (popupVoyageRef) return popupVoyageRef.placeholder;
  if (!activeView) return null;
  return tabSelections[activeView];
}
